import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

interface IVendas {
  numero: number;
  emissao: string;
  fabrica: string;
  descricao: string;
  multiplo: number;
  cliente: string;
  cpf: string;
  telefone: number;
  totalnota: number;
  total: number;
}

async function RelatorioVendas(dados: IVendas[], periodo: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  if (dados.length === 0) {
    console.error('Nenhum dado disponível para gerar o relatório.');
    return;
  }

  // Obtemos o CPF e Cliente apenas do primeiro item
  const { cpf, cliente, telefone} = dados[0];

  // Calcula o total de vendas
  const TValorvendas = dados.reduce((acc, item) => acc + (item.total || 0), 0);

  // Mapeia os dados para criar a tabela
  const venda = dados.map((vendas) => {
    const { emissao, numero, fabrica, descricao, multiplo, totalnota, total } = vendas;

    return [
      { text: numero || '-', alignment: 'center', fontSize: 8 },
      { text: moment(emissao).format('DD/MM/YYYY'), alignment: 'center', fontSize: 7 },
      { text: descricao || '-', alignment: 'center', fontSize: 8 },
      { text: fabrica || '-', alignment: 'center', fontSize: 8 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(multiplo || 0), alignment: 'center', fontSize: 8 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(totalnota || 0), alignment: 'center', fontSize: 8 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(total || 0), alignment: 'right', fontSize: 8 },
    ];
  });

  // Função para converter imagens em base64
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  // Carrega a imagem do logo
  const imageUrl = process.env.REACT_APP_URL_IMAGLOG || '';
  let imageData = '';
  try {
    imageData = await getBase64ImageFromUrl(imageUrl);
  } catch (error) {
    console.error('Erro ao carregar a imagem:', error);
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: 'Relatório de Vendas',
    footer: {
      columns: ['Esquerda', { text: 'Direita', alignment: 'right' }],
    },
    content: [
      {
        table: {
          widths: [50, '*'],
          body: [
            [
              {
                image: imageData,
                width: 80,
                border: [false, false, false, false],
              },
              {
                text: 'Relatório de Vendas',
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      
      { text: `Cliente: ${cliente || '-'}`, fontSize: 10, margin: [0, 2, 0, 5] },
      { text: `CPF/CNPJ: ${cpf || '-'}`, fontSize: 10, margin: [0, 2, 0, 5] },
      { text:  `${periodo}`, fontSize: 10, margin: [0, 2, 0, 5] },
      {
        columns: [
         
          { text: `Telefone: ${telefone || '-'}`, fontSize: 10, alignment: 'right' },
        ],
        margin: [0, -2, 18, 5],
      },
      {
        table: {
          widths: [50, 80, 80, 90, 50, 70, 70],
          body: [
            [
              { text: 'Nº do Pedido', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Data Pedido', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Descrição', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Fábrica', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Multiplo', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Total Nota', alignment: 'right', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Total', alignment: 'right', fillColor: '#dddddd', fontSize: 8 },
            ],
            ...venda,
            [
              { text: 'Total:', colSpan: 6, alignment: 'right', bold: true, fontSize: 8 },
              {},
              {},
              {},
              {},
              {},
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(TValorvendas),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
            ],
          ],
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default RelatorioVendas;
